import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { storageItemImageIdZodSchema } from "@@/shared/storage-items/storage-item-images/storage-item-image-id";
import {
    requiredTranslatableZodSchema,
    translatableZodSchema,
} from "@@/shared/translations/translation";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";
import { resourceIdZodSchema } from "../resource-id";
import { resourceMapConnectionZodSchema } from "../resource-map-connection";

const resourceGroupAddCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("RESOURCE_GROUP_ADD_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    resourceGroupId: resourceIdZodSchema,
    providerId: providerIdZodSchema,
    title: requiredTranslatableZodSchema,
    subtitle: translatableZodSchema.optional(),
    description: translatableZodSchema.optional(),
    resourceIds: z.array(resourceIdZodSchema),
    resourceMapConnection: resourceMapConnectionZodSchema.optional(),
    imageIds: z.array(storageItemImageIdZodSchema).optional(),
});

type ResourceGroupAddCommand = z.infer<typeof resourceGroupAddCommandZodObject>;

const resourceGroupAddCommandFactoryParamsZodObject =
    resourceGroupAddCommandZodObject.omit({
        _id: true,
        _type: true,
        _createdAt: true,
    });

type FactoryParams = z.infer<
    typeof resourceGroupAddCommandFactoryParamsZodObject
>;

const resourceGroupAddCommandFactory = (params: FactoryParams) => {
    const resourceGroupAddCommand: ResourceGroupAddCommand = {
        ...params,
        _id: generateId({ prefix: "resource_group_add_command__" }),
        _type: "RESOURCE_GROUP_ADD_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return resourceGroupAddCommand;
};

export {
    resourceGroupAddCommandFactory,
    resourceGroupAddCommandFactoryParamsZodObject,
    resourceGroupAddCommandZodObject,
};
export type {
    ResourceGroupAddCommand,
    FactoryParams as ResourceGroupAddCommandFactoryParams,
};
